import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toggleSidebar } from "../redux/authSlice";
import logo from "../assets/logo.png";
import { getUserData } from "../utils/localStorage";

const Header = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false); // Initialize isOpen to false
  const dropdownRef = useRef(null);
  const handleToggleSidebar = () => dispatch(toggleSidebar());

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const { userProfileData } = getUserData();

  useEffect(() => {

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [])
  
  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <Link to={"/"} className="logo d-flex align-items-center">
          <img
            src={logo}
            alt="MVN Financeseva"
            style={{ maxHeight: "100px" }}
          />
          {/*<span className="d-none d-lg-block">MVN Financeseva</span>*/}
        </Link>
        </div>
       
      {windowWidth > 1199 && <div className="d-flex align-items-center justify-content-between gap-3">
        <Link className="d-flex main-menu" to={"/"}>
          <span className="header-text">
            Home
          </span>
        </Link>
        {/*<Link className="d-flex main-menu" to={"client/list"}>
          <span className="">
            Customer
          </span>
        </Link>*/ }

        {(userProfileData.role === "ROLE_SUPER_ADMIN" || userProfileData.role === "ROLE_ADMIN") &&
          <>
          <Link className="d-flex main-menu" to={"masters"}>
            <span className="header-text">
              Masters
            </span>
          </Link>
          <Link className="d-flex main-menu" to={"lead/list"}>
            <span className="header-text">
                Lead Box
              </span>
            </Link>
          <Link className="d-flex main-menu" to={"admin-process-fee/list"}>
            <span className="header-text">
              Fees
            </span>
          </Link>

          {/*<Link className="d-flex main-menu" to={"admin-loan-file"}>
            <span className="header-text">
              Loan File
            </span>
          </Link>*/}
          <Link className="d-flex main-menu" to={"retail-pipeline"}>
            <span className="header-text">
              Retail
            </span>
          </Link>
          <Link className="d-flex main-menu" to={"wholesale-pipeline"}>
            <span className="header-text">
              Wholesale
            </span>
          </Link>
          <Link className="d-flex main-menu" to={"operation-department"}>
            <span className="header-text">
              Operation
            </span>
          </Link>

          <Link className="d-flex main-menu" to={"telecaller-department"}>
            <span className="header-text">
              TeleCaller
            </span>
          </Link>
          </>
          
        }

        {(userProfileData?.role === "ROLE_SUPER_TELECALLER") &&
          <>
          <Link className="d-flex main-menu" to={"super-telecaller-lead/list"}>
            <span className="header-text">
                Leads
              </span>
            </Link>
          {/*<Link className="d-flex main-menu" to={"super-telecaller-lead-form-create"}>
            <span className="header-text">
              Lead Form
            </span>
          </Link>*/}
          </>
        }

        {(userProfileData.role === "ROLE_TELECALLER") &&
          <>
            <Link className="d-flex main-menu" to={"telecaller-lead/list"}>
              <span className="header-text">
                Leads
              </span>
            </Link>
          {/*<Link className="d-flex main-menu" to={"telecaller-lead-form-create"}>
            <span className="header-text">
              Lead Form
            </span>
          </Link>*/}
          </>
        }

        {(userProfileData.role === "ROLE_OPERATION") &&
          <>
            <Link className="d-flex main-menu" to={"operation-lead/list"}>
            <span className="header-text">
                Leads
              </span>
            </Link>
          {/*<Link className="d-flex main-menu" to={"lead-form-operation-team-create"}>
            <span className="header-text">
              Lead Form
            </span>
          </Link>*/}
          </>
        }

        {(userProfileData.role === "ROLE_ACCOUNTANT") &&
          <>
             <Link className="d-flex main-menu" to={"accountant-process-fee/list"}>
            <span className="header-text">
              Fees
            </span>
          </Link>
          </>
        }
      </div>}

       

      
      
      
      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">
          {windowWidth < 1199 && <i
            onClick={handleToggleSidebar}
            className="bi bi-list toggle-sidebar-btn"
          ></i>}
          <li className="nav-item dropdown pe-3" ref={dropdownRef}>
            <button
              onClick={() => setIsOpen((prev) => !prev)}
              className={`btn btn-link nav-link nav-profile d-flex align-items-center pe-0 ${isOpen && "show"
                }`}
              data-bs-toggle="dropdown"
            >
              <span className="d-none d-md-block dropdown-toggle ps-2">
                {userProfileData.role.replace(/ROLE_/g, "")}
              </span>
              <span className="logout-btn">
                <i
                  className={"bi bi-power icon-300"}
                  style={{ fontSize: 25 }}
                />
              </span>
            </button>
            <ul
              className={`dropdown-menu dropdown-menu-end dropdown-menu-arrow profile ${isOpen && "show"
                }`}
              style={{
                position: "absolute",
                inset: "0px 0px auto auto",
                margin: "0px",
                transform: "translate3d(-16.6667px, 38px, 0px)",
              }}
            >
              <li className="dropdown-header">
                <h6>UserName - {userProfileData.userName}</h6>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center"
                  to="/logout"
                >
                  <i className="bi bi-box-arrow-right" />
                  <span>Sign Out</span>
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </header>
  );
};
export default Header;
